/* unplugin-vue-components disabled */import { render } from "./AuthItemCreation.vue?vue&type=template&id=a4f51140&scoped=true&ts=true"
import script from "./AuthItemCreation.vue?vue&type=script&lang=ts"
export * from "./AuthItemCreation.vue?vue&type=script&lang=ts"

import "./AuthItemCreation.vue?vue&type=style&index=0&id=a4f51140&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4f51140"]])

export default __exports__